import { arrayOf, bool, number, string, shape } from 'prop-types';
import React from 'react';
import AmpImg from 'components/AmpImg';
import { nutritionalGuideStyles } from './styles';

function NutritionalGuide(props) {
  const {
    servings,
    calories,
    primaryNutrients = [],
    labels = [],
    isAmp
  } = props;

  return (
    <div className="NutritionalGuide">
      <ul className="NutritionalGuide__list NutritionalGuide__labels">
        {labels.map(label => (
          <li className="NutritionalGuide__label" key={label}>
            {label}
          </li>
        ))}
      </ul>
      <div className="NutritionalGuide__servings">
        Per serving, based on {servings} servings. (% daily value)
      </div>
      <ul className="NutritionalGuide__list NutritionalGuide__nutrients">
        <li className="NutritionalGuide__nutrient">
          <span className="NutritionalGuide__nutrient-name">Calories </span>
          <span
            className="NutritionalGuide__nutrient-quantity"
            itemProp="calories"
          >
            {Math.round(calories / servings)}
          </span>
        </li>
        {primaryNutrients.map(nutrient => (
          <li className="NutritionalGuide__nutrient" key={nutrient.value}>
            <span className="NutritionalGuide__nutrient-name">
              <span
                className={
                  nutrient.value === 'FASAT' || nutrient.value === 'FATRN'
                    ? 'NutritionalGuide__nutrient-breakdown'
                    : ''
                }
              >
                {nutrient.label}{' '}
              </span>
            </span>
            <span className="NutritionalGuide__nutrient-quantity">
              {nutrient.quantity}
            </span>
          </li>
        ))}
      </ul>
      <footer className="NutritionalGuide__footer">
        <a
          href="https://www.edamam.com"
          className="link--muted"
          rel="nofollow noopener noreferrer"
          title="Powered by Edamam"
          target="_blank"
        >
          {isAmp ? (
            <AmpImg
              layout="fixed"
              alt="Powered by Edamam"
              maxSize={{
                width: 100,
                aspectRatio: 5
              }}
              url="https://developer.edamam.com/images/badge.png"
              originalWidth={200}
              originalHeight={40}
            />
          ) : (
            <img
              alt="Powered by Edamam"
              style={{ width: '150px' }}
              src="https://developer.edamam.com/images/badge.png"
            />
          )}
        </a>
      </footer>
      <style jsx>{nutritionalGuideStyles}</style>
    </div>
  );
}

NutritionalGuide.propTypes = {
  servings: number.isRequired,
  calories: number.isRequired,
  primaryNutrients: arrayOf(
    shape({
      label: string.isRequired,
      value: string.isRequired,
      quantity: string.isRequired,
      schemaValue: string.isRequired
    })
  ).isRequired,
  labels: arrayOf(string),
  isAmp: bool
};

NutritionalGuide.defaultProps = {
  labels: undefined,
  isAmp: false
};

export default NutritionalGuide;
